import styled from "styled-components";
import {
  BaseButtonStyles,
  BlueButtonStyles,
  ModernBlueButtonStyles,
} from "./BaseButtonStyles";

export const BaseButtonLinkDisabled = styled.a.attrs(() => ({
  disabled: true,
}))`
  ${BaseButtonStyles}
`;

export const BaseButtonLink = styled.a`
  ${BaseButtonStyles}
`;

export const BlueButtonLink = styled(BaseButtonLink)`
  ${BlueButtonStyles}
`;

export const ModernBlueButtonLink = styled(BlueButtonLink)`
  ${ModernBlueButtonStyles}
`;

export const SmallModernBlueButtonLink = styled(BlueButtonLink)`
  ${ModernBlueButtonStyles}
  --button-padding: 6px 10px;
  --button-font-size: 11px;
`;
